<template>
    <div :class="pageLoading ? 'home loading' : 'home'">
        <div>
            <div class="logo"></div>
            <form class="form">
                <el-input v-model="form.phone" type="number" oninput="value=value.replace(value.slice(10),'')"
                          class="phone" inputmode="decimal"></el-input>
                <el-input v-model="form.password" oninput="value=value.replace(value.slice(14),'')" type="password"
                          class="password"></el-input>
            </form>
            <div class="btn w-100">
                <el-button plain :disabled="loading" @click="handleLogin()"><i class="el-icon-loading"
                                                                               v-if="loading"></i>登入
                </el-button>
                <el-button type="primary" @click="goRegistered()">註冊</el-button>
                <div class="row col-12">
                    <el-checkbox v-model="checked">記住帳號密碼</el-checkbox>
                </div>

                <el-link type="primary" @click="forgotPassword()">忘記密碼?</el-link>
            </div>
        </div>
    </div>
</template>
<script>

import FN from '@/components/fn'
import {mapActions} from 'vuex'
import {getStorage, setStorage} from '@/util'

export default {
    name: 'Login',
    components: {},
    mixins: [FN],
    data() {
        return {
            pageLoading: true,
            form: {
                phone: '',
                password: ''
            },
            checked: true,
        }
    },
    mounted() {
        //先確認登入狀態
        this.checkLoginToken();
        this.setRemaberAccount();
    },
    methods: {
        ...mapActions([
            'FETCH'
        ]),
        //轉至註冊頁
        goRegistered() {
            const {href} = this.$router.resolve({name: 'Registered'})
            window.open(href, '_self')
        },
        //轉至忘記密碼頁
        forgotPassword() {
            const {href} = this.$router.resolve({name: 'ForgotPassword'})
            window.open(href, '_self')
        },
        //登入
        handleLogin() {
            const account = this.form.phone
            const password = this.form.password
            if (account === '' || account.slice(0, 2) !== '09' || account.length !== 10) {
                this.$message({
                    message: '請輸入09開頭的有效手機號碼',
                    type: 'error'
                })
            } else if (password === '' || password.length < 8 || password.length > 14) {
                this.$message({
                    message: '請輸入8-14位元密碼',
                    type: 'error'
                })
            } else {
                this.loading = true
                this.FETCH({
                    key: 'LOGIN',
                    account: account,
                    password: password
                })
                    .then((res) => {
                        if (!+res.code) {
                            //寫入登入成功資訊
                            this.handleToken(res.data)
                            this.remaberAccount();
                            const {href} = this.$router.resolve({name: 'Home'})
                            window.open(href, '_self')
                        } else {
                            this.$confirm(res.message, {
                                showCancelButton: false,
                                type: 'error'
                            }).catch(() => {
                            })
                            this.loading = false
                            //清空
                            this.form.phone = ''
                            this.form.password = ''
                        }
                    })
            }
        },
        //確認登入狀態
        checkLoginToken() {
            const token = getStorage('refreshToken')
            this.FETCH({
                key: 'LOGIN_STATE',
                refreshToken: token
            })
                .then((res) => {
                    if (!+res.code) {
                        //更新成功，儲存新的token並轉到主頁
                        this.handleToken(res.data)
                        const {href} = this.$router.resolve({name: 'Home'})
                        window.open(href, '_self')
                    } else {
                        //驗證過期，顯示登入畫面
                        this.pageLoading = false
                    }
                })
        },
        //記住帳號密碼
        remaberAccount() {
            setStorage('account', this.form.phone);
            setStorage('password', this.form.password);
        },
        //設定帳號密碼
        setRemaberAccount(){
            this.form.phone = getStorage('account');
            this.form.password = getStorage('password');
        }
    }
}
</script>
